import { createAsyncThunk } from '@reduxjs/toolkit';
import { EmailApi } from 'api/EmailApi';

import { ErrorResponse } from './ErrorResponse';

export const createSendOfferComparisonEmailThunk = (api: EmailApi) =>
  createAsyncThunk('emailService/sendOfferComparisonEmail', async (applicationId: string, thunkApi) => {
    try {
      await api.sendOfferComparisonEmail(applicationId);
    } catch (error: unknown) {
      thunkApi.rejectWithValue((error as ErrorResponse).response.data);

      throw error;
    }
  });
